import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const StyleSupportFormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: auto;
  background-color: #ffffff;
  height: auto;

  gap: 10px;
  & > *:nth-child(4) {
    grid-column: span 2;
  }
  & > *:nth-child(6) {
    grid-column: span 3;
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    display: block;
  }
`;

export const StyleDiv = styled.div<{
  $marginBottom?: number;
  $marginTop?: number;
  $flex?: boolean;
}>`
  margin-bottom: ${(props: any) => props.$marginBottom || 0}px;
  margin-top: ${(props: any) => props.$marginTop || 0}px;
  width: 100%;

  ${(props: any) =>
    props.$flex &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}
`;

export const StyleFormLabel = styled.label`
  font-size: 14px;
  color: #000000;
  margin-bottom: 5px;
  display: block;
  color: #3b3f40;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const StyleInput = styled.input<any>`
  width: 100%;
  padding: 16px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 16px;
  outline: none;
  &::placeholder {
    color: #b9b9b9;
    font-weight: 100;
    font-size: 12px;
  }
  ${(props) =>
    props.$shifted &&
    css`
      position: relative;
      top: 4px;
    `}
`;

export const StyleDownloadInfoFormContainer = styled.div`
  background-color: #ffffff;
  height: 200px;
  padding: 16px;
  display: flex;
  gap: 10px;
  justify-content: center;
`;

export const StyleCardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;
export const StyleCard = styled.div`
  flex: 1;
  height: auto;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const StyleFileUploadBox = styled.label`
  border: 1px dashed #a4dbe8;
  border-radius: 8px;
  width: 60%;
  height: 200px;
  color: #b9b9b9;
  font-size: 12px;
  cursor: pointer;
  background-color: #f8fcfd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
